export const createFontLinkWithoutPrefix = href => {
  const fontLink = document.createElement('link');
  fontLink.setAttribute('as', 'font');
  fontLink.setAttribute('rel', 'preload');
  fontLink.setAttribute('type', 'font/woff2');
  fontLink.setAttribute('href', href);
  fontLink.setAttribute('crossorigin', '');
  return fontLink;
};